<div class="contact-persons-main-wrapper">
  <form [formGroup]="documentForm" (ngSubmit)="onSubmit()">
    <div class="table-wrapper documents-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Document</th>
            <th>Upload File</th>
            <th>Issue Date</th>
            <th>Expiry Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody formArrayName="documents">
          <tr
            *ngFor="let doc of documentsArray.controls; let i = index"
            [formGroupName]="i"
          >
            <td>
              <mat-form-field appearance="fill">
                <mat-label>Document</mat-label>
                <mat-select formControlName="documentName">
                  <mat-option
                    *ngFor="let type of documentTypeData"
                    [value]="type.value"
                  >
                    {{ type.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
            <td>
              <div class="upload-file-group">
                <input
                  #fileInput
                  type="file"
                  style="display: none"
                  formControlName="file"
                  (change)="onFileSelected($event)"
                  accept=".csv, .pdf, .jpg, .jpeg, .png, .doc"
                />
                <button
                  type="button"
                  class="cmn-upload-btn"
                  (click)="fileInput.click()"
                >
                  <img
                    src="assets/images/icons/icon-upload.svg"
                    alt="Upload Icon"
                  />
                  <span>Upload File</span>
                </button>
                <div class="uploaded-file" *ngIf="fileName">
                  <h6>
                    {{ fileName }}
                    <img
                      src="assets/images/icons/icon-close.svg"
                      alt="Close Icon"
                      (click)="removeFile()"
                    />
                  </h6>
                </div>
              </div>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  placeholder="Issue Date"
                  formControlName="issueDate"
                  [max]="getMaxIssueDate(i)"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  placeholder="Expiry Date"
                  formControlName="expiryDate"
                  [min]="getMinExpiryDate(i)"
                  [disabled]="!documentsArray.at(i).get('issueDate')?.value"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <button
                type="button"
                class="add-btn"
                (click)="handleAddDocument(i)"
                [disabled]="uploadLoading"
              >
                <img src="assets/images/icons/icon-add-color.svg" alt="Add" />
                Add
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="loading-overlay" *ngIf="uploadLoading">
        <div class="loading-text">
          <p>Uploading, please wait</p><div class="loader"></div>
        </div>
      </div>
    </div>
    <div class="item-service-adding-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Document</th>
            <th>Name</th>
            <!-- <th>Document URL</th> -->
            <th>Issue Date</th>
            <th>Expiry Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of uploadedDocuments; let i = index">
            <td>{{ formatDocumentLabel(doc.documentType) }}</td>
            <td>{{ doc.documentName }}</td>
            <td>{{ doc.issueDate | date : "dd/MM/yyyy" }}</td>
            <td>{{ doc.expiryDate | date : "dd/MM/yyyy" }}</td>
            <td>
              <div class="action-wrapper">
                <img
                  src="../../../assets/images/icons/icon-delete.svg"
                  (click)="removeUploadedDocument(i, doc.id)"
                  alt="Delete"
                />
                <img
                  src="../../../assets/images/icons/icon-edit.svg"
                  (click)="editUploadedDocument(i)"
                  alt="Edit"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
